__turbopack_context__.v({
  "accountButton": "Sidebar-module__0RD8IG__accountButton",
  "active": "Sidebar-module__0RD8IG__active",
  "activeItem": "Sidebar-module__0RD8IG__activeItem",
  "adminNav": "Sidebar-module__0RD8IG__adminNav",
  "closed": "Sidebar-module__0RD8IG__closed",
  "closedWrapper": "Sidebar-module__0RD8IG__closedWrapper",
  "collapsedPopover": "Sidebar-module__0RD8IG__collapsedPopover",
  "container": "Sidebar-module__0RD8IG__container",
  "content": "Sidebar-module__0RD8IG__content",
  "footer": "Sidebar-module__0RD8IG__footer",
  "footerBottom": "Sidebar-module__0RD8IG__footerBottom",
  "footerContent": "Sidebar-module__0RD8IG__footerContent",
  "footerTop": "Sidebar-module__0RD8IG__footerTop",
  "fullWidth": "Sidebar-module__0RD8IG__fullWidth",
  "header": "Sidebar-module__0RD8IG__header",
  "logged": "Sidebar-module__0RD8IG__logged",
  "logoContainer": "Sidebar-module__0RD8IG__logoContainer",
  "nav": "Sidebar-module__0RD8IG__nav",
  "navButton": "Sidebar-module__0RD8IG__navButton",
  "navItem": "Sidebar-module__0RD8IG__navItem",
  "navSeparator": "Sidebar-module__0RD8IG__navSeparator",
  "navTitle": "Sidebar-module__0RD8IG__navTitle",
  "signInButton": "Sidebar-module__0RD8IG__signInButton",
  "signInIconOnly": "Sidebar-module__0RD8IG__signInIconOnly",
  "signInSection": "Sidebar-module__0RD8IG__signInSection",
  "toggleBtn": "Sidebar-module__0RD8IG__toggleBtn",
  "userTriggerContent": "Sidebar-module__0RD8IG__userTriggerContent",
  "userTriggerLeft": "Sidebar-module__0RD8IG__userTriggerLeft",
  "wrapper": "Sidebar-module__0RD8IG__wrapper",
});
